import { BaseApi, enhanceOpt } from '../couplingAjax'
import { Services } from '@/store/StoreTypes'

// http://172.16.103.12/message-api/doc.html#/home

const IsvApi = (request: typeof BaseApi, SERVIVE: Services) => {
    return {
        isvLogin: (opt: enhanceOpt,code: string, tenant: string) =>
            request({
                ...opt,
                url: `/auth/callback?code=${code}&tenant=${tenant}`,
                method: 'get',
            }),
    }
}

export default IsvApi
